import React, { useCallback, useEffect, useState } from 'react';
import PageContainer from 'layout/components/PageContainer';
import { ReservaTrasladoFormWrapper } from 'app/viaje/viajeTraslado/viajeTraslado/components/ViajeTrasladoFormWrapper';
import { Card } from 'shared/components';
import { TransferReservationRepetitiveForm } from '../form/TransferReservationRepetitiveForm';
import { TransferReservationRepetitiveFormType } from '../form/TransferReservationRepetitiveFormType';
import { useViajesTraslado } from 'app/viaje/services';
import { BusType } from '../../viajeTraslado/models/TransferReservation';

interface Props {
  initialValues: TransferReservationRepetitiveFormType & { id: number };
  onSubmit: (
    reservation: TransferReservationRepetitiveFormType,
    clientBusinessId: number,
    reset: any
  ) => void;
  estimatePrice: (
    trasladoFormValues: TransferReservationRepetitiveFormType,
    clientBusinessId: number
  ) => Promise<
    {
      price: number;
      distance: number;
      duration: number;
      durationTraffic: number;
    }[]
  >;
}

export const ReservaTrasladoRepetitiveEdit = ({
  initialValues,
  onSubmit,
  estimatePrice
}: Props) => {
  const ViajeTrasladoService = useViajesTraslado();
  const [optionsBuses, setOptionsBuses] = useState<BusType[]>([]);

  const getOptionsBuses = useCallback(async () => {
    const buses = await ViajeTrasladoService.getOptionsBuses();
    setOptionsBuses(buses);
  }, [ViajeTrasladoService]);

  useEffect(() => {
    getOptionsBuses();
  }, []);

  return (
    <PageContainer>
      <Card className="w-full" title="Editar reserva repetitiva">
        <div className="p-8">
          <ReservaTrasladoFormWrapper<TransferReservationRepetitiveFormType>
            onSubmit={onSubmit}
            calculateDistanceAndCost={estimatePrice}
          >
            {(params) => (
              <TransferReservationRepetitiveForm
                optionsBuses={optionsBuses}
                {...params}
                initialValues={initialValues}
              />
            )}
          </ReservaTrasladoFormWrapper>
        </div>
      </Card>
    </PageContainer>
  );
};
